import { api } from '@/api';
import { loadLocationState } from '@/engine/actions';
import { useDeviceId, usePlayLocation, useStore } from '@/engine/store';
import { createFileRoute } from '@tanstack/react-router';
import { Button } from 'ht-sdk/react';
import { SearchX } from 'lucide-react';

export const Route = createFileRoute('/no-game')({
	component: RouteComponent,
});

function RouteComponent() {
	const location = usePlayLocation();
	const deviceId = useDeviceId();

	if (!location) {
		return null;
	}

	return (
		<div className="flex h-screen w-screen items-center justify-center">
			<div className="flex aspect-video h-[55%] flex-col items-center justify-center gap-4 rounded-lg border border-sky-400 bg-sky-400/10 text-center">
				<SearchX size={48} />
				<p className="text-4xl font-bold">Geen actieve game gevonden!</p>
				<div className="mb-4 text-lg">
					<p>{location?.name ?? 'Deze locatie'} heeft op het moment geen lopend spel.</p>
					<p>Wacht tot de spelbegeleider een sessie start of wissel van locatie.</p>
				</div>
				<Button
					mode="secondary"
					onClick={() => {
						loadLocationState({ code: location.code, deviceId: deviceId });
					}}
				>
					Herladen
				</Button>
				<Button
					mode="secondary"
					onClick={async () => {
						await api.eventLogCreate({
							eventType: 'LEAVE_LOCATION',
							data: {
								locationId: location.id,
								deviceId: deviceId,
							},
						});
						useStore.getState().leaveLocation();
						window.location.reload();
					}}
				>
					Verlaat locatie
				</Button>
			</div>
		</div>
	);
}
